export default "__VITE_ASSET__Dx3X2gDw__"